export default __webpack_public_path__ + "static/media/q9.76367138.svg";